<template>
  <v-container fluid>
    <div>
      <subscription-filters
        :report-type="reportType"
        @period="selectedPeriod = $event"
        @acquisitiontypes="selectedAcquisitionTypes = $event"
        @corporatetypes="selectedCorporateTypes = $event"
        @discountcategories="selectedDiscountCategories = $event"
        @nodiscounts="
          noDiscounts = $event;
          selectedDiscountCategories = [];
        "
      />

      <v-row v-if="clubData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="clubData" :options="clubData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="oneOnOneData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="oneOnOneData" :options="oneOnOneData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="lifeData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="lifeData" :options="lifeData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="gradData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="gradData" :options="gradData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="brandData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <h2>Brand Retention &amp; Acquisition</h2>
        </v-col>
      </v-row>
      <v-row v-if="brandData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="brandData" :options="brandData"></highcharts>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SubscriptionFilters from "@/components/billing/components/SubscriptionFilters";
import SubscriptionReportMixin from "@/components/shared/mixins/SubscriptionReportMixin";

export default {
  name: "SignUps",
  mixins: [SubscriptionReportMixin],
  components: { SubscriptionFilters },
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      reportType: "SIGNUPS",
    };
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
